
import { useState, useEffect } from 'react';
import { getHomepagePapers, HomepagePapersResult } from '@/lib/api/paper-queries/getHomepagePapers';
import { toast } from 'sonner';

export const useHomepagePapers = (limit = 3) => {
  const [papersData, setPapersData] = useState<HomepagePapersResult>({
    featured: null,
    recent: [],
    isLoading: true,
    error: null
  });

  useEffect(() => {
    const fetchPapers = async () => {
      try {
        const result = await getHomepagePapers(limit);
        setPapersData(result);
      } catch (error: any) {
        console.error('Error fetching homepage papers:', error);
        setPapersData(prev => ({ 
          ...prev, 
          isLoading: false, 
          error 
        }));
        toast.error('Failed to load papers', {
          description: error.message || 'Please check your connection and try again'
        });
      }
    };

    fetchPapers();
  }, [limit]);

  return papersData;
};
